<div class="card">
  <div class="card-header flex-between">
    <h5>
      Race Reports
    </h5>
    <div class="flex-start">
      <types-selector></types-selector>
      <input type="text" class="form-control datetimepicker">
      <button-status class="flex-1" [filter]="filters['venue']" title="Venue" [multiple]="true" [items]="events"></button-status>
      <button-status class="flex-1" [filter]="filters['status']" title="Status" [multiple]="true" [items]="statuses"></button-status>
      <button-status class="flex-1" [filter]="filters['time']" title="Starts in" [multiple]="false" [items]="times"></button-status>
    </div>
  </div>
  <div class="card-body">
    <table-view [headers]="headers" [data]="races | raceFilter:filters['venue']['selected']:filters['status']['selected']:filters['time']['selected']" [loading]="loading"></table-view>
  </div>
</div>
